<template>
  <div class="home px-0 px-sm-2 px-md-4 px-lg-5 mb-3">
    <div class="px-3 mt-5 px-md-5" v-if="!isLearning">
    <h1>Bienvenido a la aplicación de aprendizaje de español</h1>
    <p>Comienza tu viaje para aprender español con nosotros.</p>
    <button class="d-block btn btn-lg btn-secondary fw-bold mx-auto" @click="startLearning">Empezar a aprender</button>
   
  <router-link to="/tenses" class="btn btn-sm btn-link fw-bold mt-3">Tense cheat sheet / Ver la hoja de trucos</router-link>

  </div>
    <verbs-table v-else class="mt-3" />
  </div>
</template>

<script>
import { useToast } from 'vue-toastification';
import VerbsTable from '../components/VerbsTableGame.vue';
export default {
  components: { VerbsTable },
  name: 'Home',
  data() {
    return {
      isLearning: false,
    };
  },
  methods: {
    startLearning() {
      // Logic to start the learning process can be added here
      const toast = useToast();
      toast.info('¡Vamos a aprender español!', {position: 'top-center', timeout: 5000});
      this.isLearning = true;
    }
  }
}
</script>

<style scoped>
.home {
  text-align: center;
}
button {
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
}
</style>